// extracted by mini-css-extract-plugin
export var externalLink = "_6k-0";
export var internalLinkLabel = "_6k-1";